const banners = [

  {
    'Title': 'Tonight At 10',
    'Type': 'link',
    'Link': 'http://www.newson6.com/story/18251082/tonight-at-10',
    'Description': 'Big reveal of that story we\'ve been talking about',
    'Target': '_self',
    'BannerTypeId': 3,
    'BannerInfoTypeMask': 7,
    'EncoderTypeId': 0,
    'Audio': false,
    'Theme': '',
    'Content': 'Livestreaming'
  },
  {
    'Title': 'Watch Live powered by',
    'Type': 'ls',
    'Link': 'javascript:GNM.liveStream(" http: //www.newson6.com/Global/category.asp?C=202152&amp;BannerId=1343");',
    'Description': 'Test Live Stream Bicycle',
    'Target': '_self',
    'BannerTypeId': 5,
    'BannerInfoTypeMask': 247,
    'EncoderTypeId': 7,
    'EncoderUrls': [{
      'EncoderUrlTypeId': 2,
      'EncoderUrlTypeTitle': 'Mobile',
      'Url': 'http://content.jwplatform.com/manifests/yp34SRmf.m3u8'
    }, {
      'EncoderUrlTypeId': 1,
      'EncoderUrlTypeTitle': 'Website',
      'Url': 'http://kotv-lh.akamaihd.net/z/KOTV_1180@97915/manifest.f4m'
    }],
    'Audio': !0,
    'Theme': '',
    'Content': 'Weather'
  },
  {
    'Title': 'A',
    'Type': 'ls',
    'Link': 'javascript:GNM.liveStream("http://www.newson6.com/Global/category.asp?C=202152&amp;BannerId=1343");',
    'Description': 'Test Live Stream Steve Jobs',
    'Target': '_self',
    'BannerTypeId': 5,
    'BannerInfoTypeMask': 247,
    'EncoderTypeId': 7,
    'EncoderUrls': [{
      'EncoderUrlTypeId': 2,
      'EncoderUrlTypeTitle': 'Mobile',
      'Url': 'http://qthttp.apple.com.edgesuite.net/1010qwoeiuryfg/sl.m3u8'
    }, {
      'EncoderUrlTypeId': 1,
      'EncoderUrlTypeTitle': 'Website',
      'Url': 'http://kotv-lh.akamaihd.net/z/KOTV_1180@97915/manifest.f4m'
    }],
    'Audio': !0,
    'Theme': '',
    'Content': 'Weather'
  },
  {
    'Title': 'Watch Live Now',
    'Type': 'ls',
    'Link': 'javascript:GNM.liveStream(" http: //www.newson6.com/Global/category.asp?C=202152&amp;BannerId=1343");',
    'Description': 'Skycam View of Tornado',
    'Target': '_self',
    'BannerTypeId': 5,
    'BannerInfoTypeMask': 247,
    'EncoderTypeId': 7,
    'EncoderUrls': [{
      'EncoderUrlTypeId': 2,
      'EncoderUrlTypeTitle': 'Mobile',
      'Url': 'http://kotv-lh.akamaihd.net/i/KOTV_1180@97915/master.m3u8'
    }, {
      'EncoderUrlTypeId': 1,
      'EncoderUrlTypeTitle': 'Website',
      'Url': 'http://kotv-lh.akamaihd.net/z/KOTV_1180@97915/manifest.f4m'
    }],
    'Audio': !0,
    'Theme': '',
    'Content': 'Weather'
  },
  {
    'Title': 'Earthquake Alert',
    'Type': 'earthquake',
    'Link': 'http://www.newson6.com/Earthquake',
    'Description': 'At 7:59AM a magnitude 5.3 was reported in Tulsa County',
    'Target': '_self',
    'BannerTypeId': 15,
    'BannerInfoTypeMask': 71,
    'EncoderTypeId': 0,
    'Audio': false,
    'Theme': '',
    'Content': ''
  },
  {
    'Title': 'Breaking News',
    'Type': 'earthquake',
    'Link': 'http://www.newson6.com/space-aliens',
    'Description': 'Police Officer Accused of Not Shooting Unarmed Man',
    'Target': '_self',
    'BannerTypeId': 0,
    'BannerInfoTypeMask': 71,
    'EncoderTypeId': 0,
    'Audio': false,
    'Theme': '',
    'Content': ''
  },
  {
    'Title': 'Live Now',
    'Type': 'earthquake',
    'Link': '',
    'Description': 'Another Extraterrestrial Landing Craft over Tulsa',
    'Target': '_self',
    'BannerTypeId': 0,
    'BannerInfoTypeMask': 71,
    'EncoderTypeId': 0,
    EncoderUrls: [{
        EncoderUrlTypeTitle: "Mobile",
        Url: 'http://d2zihajmogu5jn.cloudfront.net/bipbop-advanced/bipbop_16x9_variant.m3u8'
      },
      {
        EncoderUrlTypeTitle: "Mobile",
        Url: 'http://d2zihajmogu5jn.cloudfront.net/bipbop-advanced/bipbop_16x9_variant.m3u8'
      }
    ],
    'Audio': false,
    'Theme': '',
    'Content': ''
  }

];

const tornadoEvent = [{
    "Title": "Watch Live Now",
    "Type": "ls",
    "Link": "javascript:GNM.liveStream('http://www.news9.com/Global/category.asp?C=202211&amp;BannerId=3087');",
    "Description": "News 9 Extended Coverage",
    "Target": "_self",
    "BannerTypeId": 5,
    "BannerInfoTypeMask": 151,
    "EncoderTypeId": 8,
    "EncoderUrls": [{
        "EncoderUrlTypeId": 1,
        "EncoderUrlTypeTitle": "Website",
        "Url": "http://kwtv-lh.akamaihd.net/z/KWTV_1256@91154/manifest.f4m"
      },
      {
        "EncoderUrlTypeId": 2,
        "EncoderUrlTypeTitle": "Mobile",
        "Url": "http://kwtv-lh.akamaihd.net/i/KWTV_1256@91154/master.m3u8"
      }
    ],
    "Audio": true,
    "Theme": "",
    "Content": "Weather - Live Streaming"
  },
  {
    "Title": "Watch Live Now",
    "Type": "ls",
    "Link": "",
    "Description": "Encoder 2 Test CBS Stream",
    "Target": "_self",
    "BannerTypeId": 5,
    "BannerInfoTypeMask": 87,
    "EncoderTypeId": 3,
    "EncoderUrls": [{
        "EncoderUrlTypeId": 1,
        "EncoderUrlTypeTitle": "Website",
        "Url": "http://kwtv-lh.akamaihd.net/z/KWTV_665@91154/manifest.f4m"
      },
      {
        "EncoderUrlTypeId": 2,
        "EncoderUrlTypeTitle": "Mobile",
        "Url": " https://content.jwplatform.com/manifests/yp34SRmf.m3u8"
      }
    ],
    "Audio": true,
    "Theme": "http://ftpcontent.worldnow.com/kotv/custom/popup/severeWx_bug2.png",
    "Content": "Weather - Live Streaming"
  },
  {
    "Title": "Watch Live Now",
    "Type": "ls",
    "Link": "javascript:GNM.liveStream('http://www.news9.com/Global/category.asp?C=262098&amp;BannerId=3163');",
    "Description": "News 9 StormTracker Val Castor Tracks Severe Weather In NW Oklahoma",
    "Target": "_self",
    "BannerTypeId": 5,
    "BannerInfoTypeMask": 87,
    "EncoderTypeId": 6,
    "EncoderUrls": [{
        "EncoderUrlTypeId": 1,
        "EncoderUrlTypeTitle": "Website",
        "Url": "http://kwtv-lh.akamaihd.net/z/KWTV_1014@91154/manifest.f4m"
      },
      {
        "EncoderUrlTypeId": 2,
        "EncoderUrlTypeTitle": "Mobile",
        "Url": "http://kwtv-lh.akamaihd.net/i/KWTV_1014@91154/master.m3u8"
      }
    ],
    "Audio": true,
    "Theme": "",
    "Content": "Weather - Live Streaming"
  },
  {
    "Title": "Watch Live Now",
    "Type": "ls",
    "Link": "javascript:GNM.liveStream('http://www.news9.com/Global/category.asp?C=202211&amp;BannerId=1400');",
    "Description": "News 9 At 6:00 P.M.",
    "Target": "_self",
    "BannerTypeId": 5,
    "BannerInfoTypeMask": 119,
    "EncoderTypeId": 8,
    "EncoderUrls": [{
        "EncoderUrlTypeId": 1,
        "EncoderUrlTypeTitle": "Website",
        "Url": "http://kwtv-lh.akamaihd.net/z/KWTV_1256@91154/manifest.f4m"
      },
      {
        "EncoderUrlTypeId": 2,
        "EncoderUrlTypeTitle": "Mobile",
        "Url": "http://kwtv-lh.akamaihd.net/i/KWTV_1256@91154/master.m3u8"
      }
    ],
    "Audio": true,
    "Theme": "",
    "Content": "Livestreaming"
  },
  {
    "Title": "Watch Live Now",
    "Type": "ls",
    "Link": "",
    "Description": "News 9 StormTracker Hank Brown Tracks Severe Weather In SW OK",
    "Target": "_self",
    "BannerTypeId": 5,
    "BannerInfoTypeMask": 7,
    "EncoderTypeId": 4,
    "EncoderUrls": [{
        "EncoderUrlTypeId": 1,
        "EncoderUrlTypeTitle": "Website",
        "Url": "http://kwtv-lh.akamaihd.net/z/KWTV_666@91154/manifest.f4m"
      },
      {
        "EncoderUrlTypeId": 2,
        "EncoderUrlTypeTitle": "Mobile",
        "Url": "http://kwtv-lh.akamaihd.net/i/KWTV_666@91154/master.m3u8"
      }
    ],
    "Audio": false,
    "Theme": "http://ftpcontent.worldnow.com/kotv/custom/popup/severeWx_bug2.png",
    "Content": "Weather - Live Streaming"
  },
  {
    "Title": "Closings",
    "Type": "closings",
    "Link": "http://www.news9.com/Global/Category.asp?C=120872",
    "Description": "School & Church Closings",
    "Target": "_self",
    "BannerTypeId": 1,
    "BannerInfoTypeMask": 71,
    "EncoderTypeId": 0,
    "Audio": false,
    "Theme": "",
    "Content": "Livestreaming"
  }
]

export default banners;



// WEBPACK FOOTER //
// ./app/components/custom/ssr/TestData/testBanner.js